import React from "react";
import PropTypes from "prop-types";

/** Ícone simples de “IA / insights” (sparkles) — sem dependência de MUI icons novos. */
const AiIcon = ({ size, color, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M12 2.5l1.2 4.2L17.5 8l-4.3 1.3L12 13.5l-1.2-4.2L6.5 8l4.3-1.3L12 2.5z"
      fill={color}
    />
    <path
      d="M18.5 13l.7 2.4 2.3.7-2.3.7-.7 2.4-.7-2.4-2.3-.7 2.3-.7.7-2.4z"
      fill={color}
      opacity="0.85"
    />
    <path
      d="M6.2 14.2l.55 1.9 1.85.55-1.85.55-.55 1.9-.55-1.9-1.85-.55 1.85-.55.55-1.9z"
      fill={color}
      opacity="0.7"
    />
  </svg>
);

AiIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string
};

AiIcon.defaultProps = {
  size: 22,
  color: "currentColor",
  className: undefined
};

export default AiIcon;
